<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "CardStatementComments",
  props: {
  },
  data: () => ({

  }),
  computed: {
    ...mapState({
      show_statement_hostel: state => state.interactionStatement.show_statement_hostel,
      comments_statement: state => state.interactionStatement.comments_statement,
    }),
  },
  methods: {
    ...mapActions({

    }),
    getMarkupStatuses(commission_status){
      if (commission_status === 'Одобрил'){
        return {icon: 'fa fa-check-circle', message: 'Одобрено', color: 'green'}
      } else if (commission_status === 'Отклонил'){
        return {icon: 'fa fa-times-circle', message: 'Не одобрено', color: 'red'}
      } else {
        return {icon: 'fa fa-exclamation-circle', message: 'Рассматривается', color: 'orange'}
      }
    },
    updateStep(){
      this.$emit('updateStep')
    },
    getNameCommission(commission) {
      if (commission.role === 1) return "Начальник УСБ"
      if (commission.role === 2) return "Бухгалтер"
      if (commission.role === 3) return "Директор студгодка"
    },
    commentStatement(key) {},
  }
}
</script>

<template>
  <v-card
      style="height: 100%;"
      elevation="0"
  >
    <v-card-title class="sticky-title pa-0">
      <v-btn
          @click="updateStep"
          rounded
          elevation="0"
          small
          text
      >
        <v-icon
            class="mr-2"
            small
        >
          fa-caret-left
        </v-icon>
        Назад
      </v-btn>
    </v-card-title>

    <v-card-text class="pa-0">
      <v-list>
        <div
            v-for="(commission, index) in comments_statement"
            :key="index"
        >
          <v-list class="pa-0">
            <v-list-item>
              <v-list-item-icon>
                <v-avatar
                    color="teal lighten-4"
                    rounded
                    size="35"
                >
                  <v-icon size="20" color="teal">
                    fa fa-user
                  </v-icon>
                </v-avatar>
              </v-list-item-icon>

              <v-list-item-content>
                <div class="text-md-h6 text-sm-subtitle-1">{{ commission.commission_role }}</div>
                <v-list-item-subtitle>
                  <div>
                    <v-chip
                        small
                        rounded
                        elevation="0"
                        :color="getMarkupStatuses(commission.status_review).color"
                        outlined
                    >
                      {{getMarkupStatuses(commission.status_review).message}}
                    </v-chip>
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon size="30px" :color="getMarkupStatuses(commission.status_review).color">
                  {{getMarkupStatuses(commission.status_review).icon}}
                </v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list>
          <div v-if="commission.commission_role === 'Директор студгородка' && commission.result_place">
            Предварительная комната размещения: {{ commission.result_place }}
          </div>
          <div v-if="commission.commission_role === 'Бухгалтер' && commission.statement_hostel_contract !== 'No contract'">
            Создание договора на проживание
          </div>
          <v-list-item v-if="commission.comment">
            <v-list-item-content>
              <v-list-item-subtitle>
                <v-textarea
                    hide-details="false"
                    class="mt-3"
                    readonly
                    shaped
                    outlined
                    name="input-7-4"
                    label="Комментарий"
                    :value="commission.comment.review_comment"
                ></v-textarea>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<style scoped>

</style>